import styled from 'styled-components';

import { Flex } from 'components/Flex';
import { Icon } from 'components/Icon';
import { RouterLink } from 'components/Link';
import { colors } from 'theme/theme';

export const Link = styled(RouterLink)`
  letter-spacing: 0.44px;
  &:hover {
    text-decoration: none;
  }
`;

export const ResultsCount = styled.div`
  padding: 0 10px;
  margin: 0 10px;
  border: 1px solid ${colors.elementGrey};
  border-width: 0 1px;
  color: ${colors.lightContentGrey};
`;

export const LinkText = styled(
  ({ text = 'previous', className }: { text: string; className?: string }) => (
    <Flex alignItems="center" className={className}>
      {(() => {
        switch (text) {
          case 'next':
            return (
              <>
                <span>{getText('Next')}</span>
                <Icon name="chevron-right" size={15} />
              </>
            );

          case 'previous':
          default:
            return (
              <>
                <Icon name="chevron-left" size={15} />
                <span>{getText('Previous')}</span>
              </>
            );
        }
      })()}
    </Flex>
  ),
)`
  > :not(:first-child) {
    margin-left: 5px;
  }
  svg {
    path,
    polyline {
      fill: currentColor;
    }
  }
`;
